import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export const BundleDetails = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" data-id="element-26">
      <div className="mx-auto max-w-6xl" data-id="element-27">
        <div className="mb-12 text-center" data-id="element-28">
          <h2 className="font-serif text-3xl font-bold text-terracotta md:text-4xl" data-id="element-29">
            YOUR COMPLETE BUNDLE INCLUDES ALL 4 GUIDES:
          </h2>
          <p className="mt-2 text-xl font-medium text-text-dark" data-id="element-30">
            (Winter, Spring, Summer, and Fall)
          </p>
        </div>

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-31">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-32">
            <img src="https://cdn.magicpatterns.com/uploads/7T2sy9btBY9S8E3KXuNTSm/1.jpg" alt="All 4 Season Guides" className="w-full rounded-2xl shadow-xl" data-id="element-33" />
          </motion.div>

          {/* List */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-34">
            <ul className="space-y-6" data-id="element-35">
              <li className="flex items-start space-x-4" data-id="element-36">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-37">
                  <Check className="h-4 w-4" data-id="element-38" />
                </div>
                <span className="text-lg text-text-dark" data-id="element-39">
                  <strong data-id="element-40">Step-by-Step Guide:</strong> Do it all in 4 hours. We
                  use 10 recipes to create 20 meals!
                </span>
              </li>
              <li className="flex items-start space-x-4" data-id="element-41">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-42">
                  <Check className="h-4 w-4" data-id="element-43" />
                </div>
                <span className="text-lg text-text-dark" data-id="element-44">
                  <strong data-id="element-45">Cooking Instructions:</strong> Optimized for Instant
                  Pot, Slow Cooker, or Oven.
                </span>
              </li>
              <li className="flex items-start space-x-4" data-id="element-46">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-47">
                  <Check className="h-4 w-4" data-id="element-48" />
                </div>
                <div className="text-lg text-text-dark" data-id="element-49">
                  <strong data-id="element-50">Extensively Tested Recipes:</strong>
                  <ul className="mt-3 space-y-2 pl-2 text-base text-text-dark/80" data-id="element-51">
                    <li className="flex items-center space-x-2" data-id="element-52">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-53"></span>
                      <span data-id="element-54">Rosemary Garlic Pork Tenderloin & Potatoes</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-55">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-56"></span>
                      <span data-id="element-57">"Zero-Effort" White Chicken Lasagna</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-58">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-59"></span>
                      <span data-id="element-60">Creamy Broccoli Cheddar Soup</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-61">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-62"></span>
                      <span data-id="element-63">General Tso Chicken with Crisp Veggies</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-64">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-65"></span>
                      <span data-id="element-66">Cheesy Beef Pasta Melt</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-67">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-68"></span>
                      <span data-id="element-69">Hearty Country Beef Stew</span>
                    </li>
                    <li className="flex items-center space-x-2 font-medium italic text-terracotta" data-id="element-70">
                      <span data-id="element-71">
                        (And dozens more for every season of the year!)
                      </span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};